/**
 * Shared, serialisable top-level game state. Each field has ONE owning module that writes it;
 * everyone may read it. Owners are listed next to each field. Keep this flat and plain-data.
 */
export type GameMode = 'boot' | 'title' | 'playing' | 'paused' | 'cutscene';

export interface GameState {
  /** game wiring (src/game) + UI (pause/title) */
  mode: GameMode;
  /** loop: simulated seconds since start */
  time: number;
  /** loop: fixed steps since start */
  frame: number;
  /** economy: current cash */
  money: number;
  /** heat: wanted level 0..4 (integer). Fractional progress lives in the heat service. */
  heat: number;
  /** missions: active mission id */
  activeMissionId: string | null;
  /** missions/save: completed mission ids */
  completedMissions: string[];
  /** world: in-game clock, hours 0..24 (for lighting/ambience). */
  timeOfDay: number;
}

export function createGameState(): GameState {
  return {
    mode: 'boot',
    time: 0,
    frame: 0,
    money: 0,
    heat: 0,
    activeMissionId: null,
    completedMissions: [],
    timeOfDay: 21.5,
  };
}
